<template>
  <v-app>
    <DisconnectDialog :enable="$store.state.disconnectDialogValue" />
    <DrawerToolbar 
      :navItems="navItems" 
      :user="user" 
      :show-invoice="showInvoice"
      />
    <v-main>
      <v-container fluid>
        <router-view>
        </router-view>
      </v-container>
    </v-main>
    <Footer :connection="connection" />
    <Snackbar />
  </v-app>
</template>

<script>
import Vue from 'vue'
import { 
  DrawerToolbar, 
  Footer, 
  DisconnectDialog,
  i18n 
} from '@leapsight/portal'
import store from '@/store'
import Snackbar from '@/components/snackbar/Snackbar'
import { magentaOAuth } from '@leapsight/styleguide'

export default Vue.extend({
  name: 'App',

  components: {
    DrawerToolbar,
    Footer,
    Snackbar,
    DisconnectDialog
  },
  computed: {
    user() {
      return {
        name: store.state.user.first_name,
        last_name: store.state.user.last_name,
        avatarImage: store.state.user.photo
      }
    },
    connection() {
      return store.getters['auth/connection']
    },
    navItems() {
      if (store.getters.hasScheduledReportRole) {
        this.drawerItems.push(
          {
            text: 'Programas',
            icon: 'icon_reloj',
            to: '/reports/programas'
          }
        );
      }
      return this.drawerItems;
    }
  },
  data: () => ({
    authStatus: store.getters['auth/isTokenValid'],

    token: localStorage.getItem('ACCESS_TOKEN'),
    snackbar: true,
    drawerItems: [
      {
        text: 'Nuevo',
        icon: 'icon_create_report',
        to: '/reports/new'
      },
      {
        text: 'Lista',
        icon: 'icon_saved_reports',
        to: '/reports/lista'
      }
    ]
  }),
  methods: {
    showInvoice() {
      return store.getters.isAdmin && store.getters.getCountryId === 'ar'
    }
  },
  created() {
    if (store.getters['auth/isLoggedIn']) {
      store.dispatch('auth/checkTokenIsActive').then(response => {
        store.state.auth.connection || store.dispatch('auth/getConnection', {})
        switch (response) {
          case true:
            store.dispatch('auth/establishConnection')
            break
          case false:
            magentaOAuth
              .refreshToken()
              .then(response =>
                response.status == 200
                  ? store.dispatch('auth/establishConnection')
                  : store.dispatch('auth/logout')
              )
              .catch(err => store.dispatch('auth/logout'))
            break
        }
      })
    }
  },
  mounted() {
    window.addEventListener('single-spa:app-change', event => {
      const mountedApp = Object.keys(event.detail.newAppStatuses)
      if (mountedApp[0] == '@leapsight/reports') {
        return (window.document.title = `${i18n.t(
          'portal.general.app_list.labels.strix'
        )} - ${i18n.t('general.apps.reports')}`)
      }
    })
  }
})

</script>
<style lang="scss" scoped>
.conteiner {
  flex: 1;
  margin: 2%;
}

.v-main__wrap {
  >.container {
    height: 100%;
  }
}
</style>
